import { render } from "./Priority.vue?vue&type=template&id=74b7f225&scoped=true"
import script from "./Priority.vue?vue&type=script&lang=js"
export * from "./Priority.vue?vue&type=script&lang=js"

import "./Priority.vue?vue&type=style&index=0&id=74b7f225&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b7f225"]])

export default __exports__